import React, { useState } from 'react';
import {
  Star,
  Send,
  Award,
  ArrowLeft,
  Heart,
  CheckCircle,
  Download,
  Share2
} from 'lucide-react';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { supabase } from '../lib/supabase';


const FeedbackPage = ({ category, onBack, onFinish }) => {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [recommend, setRecommend] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const categoryNames = {
    religiosa: 'Religiosa',
    educadora: 'Educadora',
    familia: 'Familia Acogiente',
  };

  // 🔹 Mapeo para Supabase (ENUM)
  const categoryMap = {
    religiosa: 'Religiosa',
    educadora: 'Educadora',
    familia: 'Familia Acogiente',
  };

  // 🔹 Mapeo de recomendación a texto
  const recommendMap = {
    definitely: 'Definitivamente sí',
    probably: 'Probablemente sí',
    'not-sure': 'No estoy seguro/a',
    no: 'Probablemente no',
  };

  // 🔹 Envío real a backend / Supabase
  const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

 const feedbackData = {
  categoria: categoryMap[category],
  feedback: JSON.stringify({
    rating,
    recommend: recommendMap[recommend],
    comment: feedback,
  }),
};



  const { error } = await supabase
    .from('feedback_curso')
    .insert([feedbackData]);

  if (error) {
    console.error('Error guardando feedback:', error);
    alert('Ocurrió un error al guardar tu feedback. Intenta nuevamente.');
    setIsSubmitting(false);
    return;
  }

  setIsSubmitted(true);
  setIsSubmitting(false);
};
  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-primary-foreground flex items-center justify-center px-6">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-green-500/15 rounded-full blur-[120px] animate-pulse" />
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-primary/15 rounded-full blur-[120px]" />
        </div>

        <div className="relative z-10 text-center max-w-2xl">
          <div className="w-24 h-24 mx-auto mb-8 rounded-full bg-gradient-to-br from-green-500/20 to-emerald-500/20 border border-green-500/30 flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-green-500" />
          </div>

          <div className="mb-8 p-8 rounded-3xl bg-gradient-to-br from-primary/10 to-accent/10 border border-primary/30 backdrop-blur-sm">
            <Award className="w-16 h-16 mx-auto text-primary mb-4" />
            <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2">
              ¡Felicidades!
            </h1>
            <p className="text-muted-foreground text-lg mb-6">
              Has completado exitosamente la Capacitación de Cuidadores de Adopción
            </p>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/20 border border-primary/30">
              <span className="text-primary text-sm font-medium">
                Categoría: {categoryNames[category]}
              </span>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 text-muted-foreground">
            <span>Gracias por tu compromiso con los niños</span>
            <Heart className="w-5 h-5 text-primary fill-primary" />
          </div>

          <button
            onClick={onFinish}
            className="mt-8 text-primary hover:text-primary/80 transition-colors flex items-center gap-2 mx-auto"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver al Inicio
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-primary-foreground">
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#8AA888]/15 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#4A7C7E]/15 rounded-full blur-[120px]" />
      </div>

     <div className="fixed top-0 left-0 right-0 z-50 bg-primary-foreground/95 backdrop-blur-xl border-b border-[#8AA888]/20">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-[#5A7A7C] hover:text-[#2D4A4F] transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Volver al curso</span>
          </button>
        </div>
      </div>

      <div className="relative z-10 pt-24 pb-16">
        <div className="max-w-2xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-[#8AA888]/20 to-[#4A7C7E]/20 border border-[#8AA888]/30 flex items-center justify-center">
              <Award className="w-10 h-10 text-[#8AA888]" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-[#2D4A4F] mb-4">
              ¡Casi terminamos!
            </h1>
            <p className="text-[#5A7A7C] text-lg">
               Tu opinión nos ayuda a mejorar. Por favor, comparte tu experiencia.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-8">
            {/* ⭐ Estrellas */}
            <div className="p-6 rounded-2xl bg-white/60 border border-[#8AA888]/20">
              <Label className="text-[#2D4A4F] text-lg mb-4 block">
                ¿Cómo calificarías tu experiencia general?
              </Label>
              <div className="flex items-center justify-center gap-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHoverRating(star)}
                    onMouseLeave={() => setHoverRating(0)}
                    className="p-1 transition-transform hover:scale-110"
                  >
                    <Star
                      className={`w-10 h-10 ${
                        star <= (hoverRating || rating)
                          ? 'text-yellow-500 fill-yellow-500'
                          : 'text-[#8AA888]/40'
                      }`}
                    />
                  </button>
                ))}
              </div>
            </div>

            {/* 👍 Recomendación */}
            <div className="p-6 rounded-2xl bg-white/60 border border-[#8AA888]/20">
              <Label className="text-[#2D4A4F] text-lg mb-4 block">
                ¿Recomendarías este curso a otros cuidadores?
              </Label>
              <RadioGroup value={recommend} onValueChange={setRecommend} className="space-y-3">
                {[
                  { value: 'definitely', label: 'Definitivamente sí' },
                  { value: 'probably', label: 'Probablemente sí' },
                  { value: 'not-sure', label: 'No estoy seguro/a' },
                  { value: 'no', label: 'Probablemente no' },
                ].map((option) => (
                  <div key={option.value} className="flex items-center space-x-3">
                    <RadioGroupItem value={option.value} id={option.value} />
                    <Label htmlFor={option.value}>{option.label}</Label>
                  </div>
                ))}
              </RadioGroup>
            </div>

            {/* 💬 Comentario */}
            <div className="p-6 rounded-2xl bg-white/60 border border-[#8AA888]/20">
              <Label htmlFor="feedback" className="text-[#2D4A4F] text-lg mb-4 block">
                ¿Cómo el curso te ayudo a mejorar el acompañamiento del cuidado de tu niño?
              </Label>
              <Textarea
                id="feedback"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                placeholder="Comparte tu experiencia y ayúdanos dejando tu sugerencia para mejorar el curso..."
                className="min-h-[120px]"
              />
            </div>

            <Button
              type="submit"
              disabled={!rating || isSubmitting}
              className="w-full bg-gradient-to-r from-[#8AA888] to-[#4A7C7E] text-white py-6 text-lg font-semibold rounded-full"
            >
              {isSubmitting ? 'Enviando...' : 'Enviar Feedback'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPage;
